import type { SuggestionItem } from "@digdir/designsystemet-react";
import { z } from "zod";
import type { VarmeSelskapDto } from "@/api/generated";

const selskapId = z.string();
const valgtLeverandoer = z.object({
  label: z.string(),
  value: selskapId,
});
export type LeverandoerSelected2 = z.infer<typeof valgtLeverandoer> | undefined;
export type LeverandoerSelected = SuggestionItem;

const finnLeverandoerFormBaseSchema = z.object({
  leverandoer: valgtLeverandoer.optional(),
  kanIkkeBestillesHer: z.array(selskapId),
});

type FinnLeverandoerFormBaseValues = z.infer<
  typeof finnLeverandoerFormBaseSchema
>;

export const finnLeverandoerFormSchema = finnLeverandoerFormBaseSchema
  .refine((data) => data.leverandoer !== undefined, {
    path: ["leverandoer"],
    message: "pages.finn-leverandoer.form.leverandoer.paaakrevd",
  })
  .refine((data) => !leverandoerKanIkkeBestillesHer(data), {
    path: ["kanIkkeBestillesHer"],
    message: "pages.finn-leverandoer.form.leverandoer.kan-ikke-bestilles-her",
  });

export type finnLeverandoerFormValues = z.infer<
  typeof finnLeverandoerFormSchema
>;

export function getDefaultLeverandoerFormValues(
  leverandoerer: VarmeSelskapDto[] | undefined,
  valgtLeverandoer?: LeverandoerSelected,
): finnLeverandoerFormValues {
  return {
    leverandoer: valgtLeverandoer,
    kanIkkeBestillesHer: finnLeverandoererKanIkkeBestillesHer(leverandoerer),
  };
}

function finnLeverandoererKanIkkeBestillesHer(
  leverandoerer: VarmeSelskapDto[] | undefined,
): string[] {
  return (leverandoerer || [])
    .filter((l) => l.harEgenLøsning)
    .map((l) => l.organisasjonsnummer);
}

function leverandoerKanIkkeBestillesHer(
  data: FinnLeverandoerFormBaseValues,
): boolean {
  const kanIkkeBestillesHer =
    (data.leverandoer?.value &&
      data.kanIkkeBestillesHer.includes(data.leverandoer?.value)) ||
    false;
  return kanIkkeBestillesHer;
}
